var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('drukker'),_c('brieven'),_c('s-m-s'),_c('emails'),_c('huisarts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }